import fetch from "../axiosHelper";

export async function getConfig() {
    return await fetch("/api/paymentConf", "get", null)
}

export async function updateConfig(data : any) {
    return await fetch("/api/paymentConf", "put", data)
}
